import { SSNSchema } from '@components/validation/ssn';

export const required = (value) => (value ? undefined : 'This field is required.');

export const emailAddress = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Please enter a valid email address.' : undefined;

export const phoneNumber = (value) =>
  value && !/^\d{3}-\d{3}-\d{4}$/i.test(value) ? 'Please enter a 10-digit phone number.' : undefined;

export const fedTaxId = (value) =>
  value && !/^\d{2}-\d{7}$/i.test(value) ? 'Please enter a valid 9-digit EIN, for example 12-3456789.' : undefined;

export const dob = (value) =>
  value && !/^\d{2}\/\d{2}\/\d{4}$/i.test(value) ? 'Please enter the date as MM/DD/YYYY.' : undefined;

export const ssn = (value) => {
  if (value && !/^(\d{3}|\*{3})-(\d{2}|\*{2})-\d{4}$/i.test(value)) {
    return 'Please enter your 9-digit Social Security number (XXX-XX-XXXX).';
  }

  try {
    const result = SSNSchema.parse(value?.toString());
    return undefined;
  } catch (error) {
    return "This doesn't look like a valid Social Security number. Please check it.";
  }
};

export const nonEmptyString = (value) => {
  if (!value.trim()) {
    return "This field can't be blank.";
  }

  return undefined;
};
